import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchOverlay from "./SearchOverlay";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/category/variety", label: "综艺" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
          scrolled || !isHome
            ? "border-b border-background-200/70 bg-background-50/95 backdrop-blur"
            : "bg-gradient-to-b from-black/70 to-transparent"
        }`}
      >
        <div className="mx-auto flex h-16 items-center gap-4 px-4 md:h-[72px] md:px-8">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-play-fill text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              91视频<span className="text-primary-500">在线观看</span>
            </span>
          </Link>

          <nav className="ml-6 hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2 text-sm font-medium transition ${
                    isActive
                      ? "text-primary-500"
                      : "text-foreground-700 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              className="flex cursor-pointer items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2 text-sm text-foreground-600 transition hover:border-primary-300 hover:text-foreground-950 md:px-4"
            >
              <i className="ri-search-line text-base"></i>
              <span className="hidden md:inline">搜索影视</span>
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 bg-background-100 text-foreground-950 md:hidden"
              aria-label="打开菜单"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `rounded-md px-4 py-3 text-sm font-medium transition ${
                      isActive
                        ? "bg-primary-100/70 text-primary-500"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <button
                type="button"
                onClick={() => {
                  setMenuOpen(false);
                  setSearchOpen(true);
                }}
                className="mt-2 flex cursor-pointer items-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
              >
                <i className="ri-search-line"></i>
                搜索影视
              </button>
            </nav>
          </div>
        )}
      </header>

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}